import { Switch } from '@/components/ui/switch';
import OrthographicCube from '@/components/viewer/OrthographicCube';
import PerspectiveCube from '@/components/viewer/PerspectiveCube';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';
import { useTranslation } from 'react-i18next';

interface OrthographicPerspectiveToggleProps {
  isOrthographic: boolean;
  onToggle: (value: boolean) => void;
}

export function OrthographicPerspectiveToggle({
  isOrthographic,
  onToggle,
}: OrthographicPerspectiveToggleProps) {
  const { t } = useTranslation('common');
  return (
    <div className="flex items-center gap-2">
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="cursor-help">
              <PerspectiveCube className="h-4 w-4 text-synergy-text-primary" />
            </div>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            className="border-synergy-neutral-700 bg-synergy-background-2 text-synergy-text-primary"
          >
            <p>{t('viewer.perspective')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <Switch checked={isOrthographic} onCheckedChange={onToggle} />

      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="cursor-help">
              <OrthographicCube className="h-4 w-4 text-synergy-text-primary" />
            </div>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            className="border-synergy-neutral-700 bg-synergy-background-2 text-synergy-text-primary"
          >
            <p>{t('viewer.orthographic')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
